import { useEffect } from "react";
import {
  Button,
  Grid,
  TextField,
  MenuItem,
  Select,
  Typography,
  Divider,
} from "@mui/material";

import { device, operatingSystem, problem } from "../../model/dto";
import { observer } from "mobx-react-lite";
import { useCustDiagStore } from "../../contexts/RootStoreProvider";
import { Logo } from "../Logo";
import React from "react";

const InitialProblemForm = (props: any) => {
  const custDiagStore = useCustDiagStore();

  const deviceItems = custDiagStore.deviceList!.map((dev: device) => (
    <MenuItem key={dev.deviceTypeId} value={dev.deviceTypeId}>
      {dev.name}
    </MenuItem>
  ));

  const problemItems = custDiagStore.problemList.map((prob: problem) => (
    <MenuItem key={prob.problemId} value={prob.problemId}>
      {prob.name}
    </MenuItem>
  ));

  const osItems = custDiagStore.osList!.map((os: operatingSystem) => (
    <MenuItem key={os.operatingSystemId} value={os.operatingSystemId}>
      {os.name}
    </MenuItem>
  ));

  useEffect(() => {
    custDiagStore.getDeviceTypes();
  }, []);

  useEffect(() => {}, [custDiagStore.problemList]);

  function handleDeviceChange(e: any, d: any) {
    custDiagStore.currentCustDiag.devicetypeId = e.target.value;
    custDiagStore.getProblemTypes();
  }

  function handleProblemChange(e: any, d: any) {
    custDiagStore.currentCustDiag.problemId = e.target.value;
    custDiagStore.getOSTypes();
  }

  function handleOsChange(e: any, d: any) {
    custDiagStore.currentCustDiag.operatingSystemId = e.target.value;
  }

  function handleTextMakeChange(e: any) {
    custDiagStore.currentCustDiag.make = e.target.value;
  }
  function handleTextModelChange(e: any) {
    custDiagStore.currentCustDiag.model = e.target.value;
  }

  function handleStartDiagnosis(e: any) {
    //Validate Answers
    //Move to Diagnosis Wizard
    custDiagStore.startDiagnosis();
  }

  const style = { backgroundColor: "#001f3d", color: "white" };

  const dropdownMenuProps = {
    menuStyle: {
      border: "1px solid black",
      borderRadius: "5%",
      backgroundColor: "white",
    },
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={style}
    >
      <Grid item xs={8}>
        <Logo />
      </Grid>

      <Grid item padding={1}>
        <Typography gutterBottom variant="h2" align="center" component="div">
          Diagnostic Wizard
        </Typography>
      </Grid>

      <Grid item xs={10} padding={2}>
        <Typography gutterBottom variant="h6" component="div">
          Before we can diagnose your problem, we will need some primarily
          information.<br></br>
          Please fill in the below and click on the 'Start Wizard' button when
          ready.
        </Typography>
      </Grid>
      <Divider />
      <Grid item xs={3} padding={2}>
        <Typography gutterBottom variant="h4" component="div">
          What would you like help with?
        </Typography>
      </Grid>

      <Grid container justifyContent={"center"}>
        <Grid item>
          <Typography variant={"h4"}>My</Typography>
        </Grid>
        <Grid item xs={5} md={5} lg={5} padding={1}>
          <Select
            fullWidth
            defaultValue={0}
            onChange={handleDeviceChange}
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Select Device</MenuItem>
            {deviceItems}
          </Select>
        </Grid>
        <Grid item>
          <Typography variant={"h4"}>Is</Typography>
        </Grid>
        <Grid item xs={5} md={5} lg={5} padding={1}>
          <Select
            fullWidth
            defaultValue={0}
            onChange={handleProblemChange}
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Select Your Problem</MenuItem>
            {problemItems}
          </Select>
        </Grid>
      </Grid>

      <Grid container spacing={0} style={style}>
        <Grid item xs={5} md={5} lg={5} padding={1}>
          <Typography variant={"h4"} align="right">
            and i Am Running
          </Typography>
        </Grid>

        <Grid item xs={5} md={5} lg={5} padding={1}>
          <Select
            fullWidth
            defaultValue={0}
            onChange={handleOsChange}
            style={{ backgroundColor: "white" }}
          >
            <MenuItem value={0}>Select Operating System</MenuItem>
            {osItems}
          </Select>
        </Grid>
      </Grid>

      <Grid container rowSpacing={1} justifyContent="center" spacing={5}>
        <Grid item xs={12} md={12}>
          <Typography align="center" variant={"h4"} paddingTop={5}>
            My devices make and model is
          </Typography>
        </Grid>
        <Grid item xs={5} md={5} lg={5}>
          <TextField
            id={"make"}
            onChange={handleTextMakeChange}
            placeholder="Enter Make"
            fullWidth
            style={{ backgroundColor: "white" }}
          ></TextField>
        </Grid>
        <Grid item xs={5} md={5} lg={5}>
          <TextField
            id={"model"}
            onChange={handleTextModelChange}
            placeholder="Enter Model"
            fullWidth
            style={{ backgroundColor: "white" }}
          ></TextField>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12} padding={2}>
        <Button
          onClick={handleStartDiagnosis}
          variant="contained"
          size="large"
          style={{ backgroundColor: "#f45111" }}
        >
          Start Diagnosis Wizard
        </Button>
      </Grid>
    </Grid>
  );
};

InitialProblemForm.propTypes = {};

export default observer(InitialProblemForm);
